import { render, staticRenderFns } from "./PrimaryCategory.vue?vue&type=template&id=00196a8e&scoped=true&"
import script from "./PrimaryCategory.vue?vue&type=script&lang=js&"
export * from "./PrimaryCategory.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryCategory.vue?vue&type=style&index=0&id=00196a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00196a8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
